import { useMemo } from "react";

import {
  getMineSubsidenceOption,
  getMineSubsidenceScheduledOption,
} from "@covertree/new-business-mappings";
import type { PolicyUnit } from "@covertree/new-business-graphql";

import {
  selectEndorsementPolicyLevelCoverages,
  selectEndorsementUnitLevelCoverages,
  selectIsViewOnly,
  useEndorsementSelector,
} from "@redux/slices/endorsement";
import { useEndorsementOutletContext } from "@layouts/EndorsementLayout/EndorsementLayout";
import { useEndorsementStepGuard } from "@layouts/EndorsementLayout/hooks/useEndorsementStepGuard";

import { buildExtraCoverages } from "./ExtraCoverages/extraCoverages";

export const useCoverageStep = () => {
  const { policy } = useEndorsementOutletContext();
  const { redirectTo } = useEndorsementStepGuard();

  const viewOnly = useEndorsementSelector(selectIsViewOnly);
  const unitLevelCoverages = useEndorsementSelector(
    selectEndorsementUnitLevelCoverages
  );
  const policyLevelCoverages = useEndorsementSelector(
    selectEndorsementPolicyLevelCoverages
  );

  const extraCoverages = useMemo(() => {
    if (!unitLevelCoverages) return [];

    // Mine Subsidence copy varies by state and usage. Both option helpers read
    // only those two fields, so the endorsed policy's own unit is enough.
    const unit = {
      usage: policy.mainUnitType,
      address: { state: policy.units?.[0]?.address?.state },
    } as PolicyUnit;

    return buildExtraCoverages(unitLevelCoverages, policyLevelCoverages, {
      mineSubsidenceOption: getMineSubsidenceOption(unit),
      mineSubsidenceScheduledOption: getMineSubsidenceScheduledOption(unit),
    });
  }, [unitLevelCoverages, policyLevelCoverages, policy]);

  return {
    viewOnly,
    redirectTo,
    extraCoverages,
  };
};
